/** Cookie name shared across all subdomains. */
export const CONSENT_COOKIE_NAME = "pex-consent";

/**
 * Increment this string when new consent categories are added.
 * Any stored cookie with a different version will be treated as missing,
 * causing the banner to re-prompt.
 */
export const CONSENT_COOKIE_VERSION = "1";

/** 1 year in seconds. */
export const CONSENT_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;
